import {useAuth0} from "@auth0/auth0-react";

export function useContractAPI() {
    const {getAccessTokenSilently} = useAuth0();

    const fetchWithAuth = async (url, options = {}) => {
        const accessToken = await getAccessTokenSilently();
        const headers = new Headers(options.headers || {});
        headers.append('Authorization', `Bearer ${accessToken}`);
        return fetch(url, {...options, headers});
    };

    const previewContract = async (contractPreviewDto) => {
        try {
            const url = `${process.env.REACT_APP_BACK_API}/reservations/admin/contract/preview`;
            const response = await fetchWithAuth(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(contractPreviewDto)
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            return await response.blob();
        } catch (error) {
            console.error('Error previewing contract:', error);
            throw error;
        }
    };

    return {
        previewContract,
    };
}
